<template>
    <v-card flat class="ma-3 mb-11 table-impression">

        <v-card-title>

            <v-col class="d-flex justify-center align-center" :cols="isMobile ? '12' : ''">

                <div class="display-1 d-flex flex-column justify-center align-center text-title font-weight-bold mt-n8"> {{$t('dash_overview.impression_loc')}} </div>

            </v-col>

            <v-col class="d-flex justify-center align-center ">

                <div>
                    <v-text-field class='field-search' outlined v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details ></v-text-field>
                    
                </div>

            </v-col>

        </v-card-title>

        <div>

        <v-data-table 
            class='overflow-x-hidden table-impressions' 
            hide-default-header 
            :headers="headers" 
            :items="dashData" 
            :search="search"
        >

            <template v-slot:header="props">

                <thead>

                    <tr>

                        <th>
                            <div class="header-text text-center"> {{ props.props.headers[0].text }} </div>
                        </th>

                        <th>
                            <div class="header-text text-center"> {{ props.props.headers[1].text }} </div>
                        </th>

                        <th>
                            <div class="header-text "> {{ props.props.headers[2].text }} </div>
                        </th>

                        <th>
                            <div class="header-text "> {{ props.props.headers[3].text }} </div>
                        </th>

                        <th>
                            <div class="header-text"> {{ props.props.headers[4].text }} </div>
                        </th>

                    </tr>

                </thead>

            </template>

            <template v-slot:item="props" class="">

                <tr class="row-impression">

                    <td>
                        <div class="row-text-1 "> {{ props.item.date | dateTransform }} </div>
                    </td>

                    <td>
                        <div class="row-text-1">{{ props.item.searched_address }} </div>
                    </td>

                    <td>
                        <div class="row-text-1 text-truncate text-center">{{ props.item.ip }} </div>
                    </td>

                    <td>
                        <div class="row-text-1 ">{{ props.item.city }} </div>
                    </td>

                    <td>
                        <div class="row-text-1 ">{{ (props.item.coordinates[1]).toFixed(3) + ' , ' + (props.item.coordinates[0]).toFixed(3) }} </div>
                    </td>

                </tr>

            </template>

        </v-data-table>

        </div>

    </v-card>
</template>

<script>
import vueI18n from '../../../plugins/vue-i18n'
import { dashOverviewFilters } from '../../../filters/dashOverviewFilters'

export default {
    name: 'ImpressionByLocationTableContainer',
    data() {
        return {
            search: '',
            page: '',
        }
    },

    filters: {

        ...dashOverviewFilters

    },

    computed: {

        headers() {
            return [{
                    text: vueI18n.t('date_h'),
                    value: 'date'
                },
                {
                    text: vueI18n.t('address_h'),
                    value: 'searched_address'
                },
                {
                    text: vueI18n.t('ip'),
                    value: 'ip'
                },
                {
                    text: vueI18n.t('provider_dashboard.city_h'),
                    value: 'city'
                },
                {
                    text: vueI18n.t('coord_h'),
                    value: 'coordinates'
                },
            ]
        },


    },

    props: ['dashData']

}
</script>

<style scoped>

    .card {

        border-style: solid;
        border-color: #3fbdbd;
        border-radius: 8px;
        border-width: 3px
    }

    .text-title {

        color: #3fbdbd;

    }

    .header-text {

        margin-left: 80px;
        color: orange;
        font-size: 17px;

    }

    .row-text-1 {

        margin-left: 60px;

    }

    .field-search {

        border: 2px solid #3fbdbd;
     

    }

    tr:nth-child(even) {

        background: rgb(236, 235, 235)
    }

    tr:nth-child(odd) {

        background: #FFF
    }

</style>
